import InputGeneric, { InputGenericProps } from './InputGeneric';

export type InputTextProps = Omit<InputGenericProps, 'type'> & { type?: HTMLInputElement['type'] };

export default function InputText(props: InputTextProps) {
  return <InputGeneric {...props} type={props.type ?? 'text'} />;
}
